import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { units } from '@hbf/dsl';

interface Props {
  // true if the contents should be centered
  centered?: boolean;

  // additional class to give to class text component
  className?: string;
}

const useStyles = makeStyles()({
  root: {
    padding: units.txb(0, 1, 1),

    '& p:last-child': {
      margin: 0,
    },

    '&:first-child': {
      paddingTop: units.rem(1),
    },
  },
  centered: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
});

const Text: React.FC<Props> = ({ children, centered, className, ...rest }) => {
  const { classes, cx } = useStyles();

  return (
    <div
      className={cx(
        [classes.root],
        {
          [classes.centered]: centered,
        },
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
};

export { Text };
